<template>
  <router-link :to="isLanding ? '/getstarted' : '/'">
    <TrivagoLogoWeb
      class="tw:cursor-pointer"
      :class="
        isLanding ? 'tw:w-auto tw:h-[18px] tw:xs:h-[22px] tw:w-full' : 'tw:hidden tw:sm:inline-block tw:w-56 tw:h-16'
      "
      data-testid="studio-icon"
    />
    <span class="visually-hidden">trivago Business Studio</span>
    <TrivagoLogo
      v-show="!isLanding"
      class="tw:w-24 tw:md:w-56 tw:inline-block tw:sm:hidden tw:aspect-[125/38]"
      data-testid="studio-icon"
    />
  </router-link>
</template>

<script setup>
import TrivagoLogo from '@/components/icons/TrivagoLogo.svg?component'
import TrivagoLogoWeb from '@/components/icons/TrivagoLogoWeb.svg?component'

defineProps({
  isLanding: {
    type: Boolean,
    default: false,
  },
})
</script>
